<template>
    <b-form class="main-content container body-content main mt-4" @submit.prevent="handleLogin">
        <b-modal @ok="enableCookies" @cancel="blockCookies"
                 ref="modal" size="md" centered
                 :no-stacking="true" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true"
                 title="Diese Website verwendet Cookies"
                 okTitle="Cookies zulassen"
                 cancelTitle="Keine Cookies zulassen">
            <div class="text-center">
                Wir verwenden Cookies, um Anmeldung und Einstellungen für die Website lokal zu speichern.<br>
                Die Cookies werden nicht an dritte weiter gegeben.
            </div>
        </b-modal>
        <b-form-group label-cols-sm="4" label-cols-lg="2" label="Benutzername" label-for="text-Benutzername">
            <b-form-input :class="darkmode ? 'bg-dark text-light border-secondary' : ''" id="text-Benutzername" size="12" v-model="userLogin.username" type="text" required />
        </b-form-group>

        <b-form-group label-cols-sm="4" label-cols-lg="2" label="Passwort" label-for="text-Passwort">
            <b-form-input :class="darkmode ? 'bg-dark text-light border-secondary' : ''" id="text-Passwort" v-model="userLogin.password" type="password" required />
        </b-form-group>

        <b-form-group label-cols="6" label-cols-lg="2" label="Angemeldet bleiben" label-for="text-Anmeldung">
            <b-form-checkbox id="text-Anmeldung" class="mt-2" v-model="userLogin.angemeldetBleiben" />
        </b-form-group>

        <b-button variant="primary" class="d-sm-none d-block" block type="submit">
            Login
            <b-spinner v-if="loading" small />
        </b-button>
        <b-button variant="primary" class="d-none d-sm-block" type="submit">
            Login
            <b-spinner v-if="loading" small />
        </b-button>
        <a href="#/impressum">Impressum</a>
    </b-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { setCookie, getCookie, setAlert, disableCookies } from '../tools'
import { login } from '../store/apiHelper'
import { BFormInput, BFormCheckbox, BSpinner } from "bootstrap-vue"
export default {
    name: "Login",
        components: {
        BFormInput, 
        BFormCheckbox,
        BSpinner
    },
    computed: mapGetters(['darkmode']),
    data() {
        return {
            userLogin: {
                username: "",
                password: "",
                angemeldetBleiben: false
            },
            loading: false
        }
    },
    methods:{
        ...mapActions(['startAnfragenInterval', 'stopAnfragenInterval']),
        async handleLogin() {
            this.loading = true
            try {
                var token = await login(this.userLogin)
                if (this.userLogin.angemeldetBleiben)
                    setCookie({ name: 'bszwmloginToken', value: token, exdays: 3})
                this.startAnfragenInterval()
                this.$router.push('/')
            } catch (err) {
                if (err.response.status == 403)
                    this.$router.push({ name: 'Register', params: { userLogin: this.userLogin } })
                else
                    setAlert(this, err.response.data, 'Anmeldung fehlgeschlagen', 'danger')
            }
            this.loading = false
        },
        blockCookies() {
            disableCookies()
        },
        enableCookies(){
            setCookie({ name: 'enableCookies', value: true, exdays: 3})
        }
    },
    mounted(){
        this.stopAnfragenInterval()
        var cookiesEnabled = getCookie('enableCookies') == undefined ? false : true
        if(!this.$route.query.redirect && !cookiesEnabled)
            this.$refs.modal.show()
    }
}
</script>